// @version V0.0.3 [20221114] : set_forms change to JSON.parse, to stop reactify on previous data
// @version V0.0.2 [Tuesday - 20210112_105450] : add ADD_TO_OPTION , UPDATED_IN_OPTION, REMOVE_FROM_OPTION
// @version V0.0.1 [Saturday - 20210109_101255] : init
import {
    ADD_IN_LIST,
    ADD_TO_OPTION,
    REMOVE_FROM_OPTION,
    REMOVE_IN_LIST,
    REMOVE_ROW,
    SET_FORM,
    SET_FORMS,
    SET_LIST,
    SET_LOADING,
    SET_OPTION,
    UPDATE_IN_LIST,
    UPDATE_IN_OPTION
} from "../constant-types";

/**
 * FORM
 */
export const defaultSetFormMutation = {
    [SET_FORM](state, payload) {
        Object.assign(state.rows[0], payload)
    },
}

export const defaultSetFormsMutation = {
    [SET_FORMS](state, payload) {
        state.rows = JSON.parse(JSON.stringify(payload))
    },
}

/**
 * LIST
 */
export const defaultSetListMutation = {
    [SET_LIST](state, fetchedList) {
        state.list = fetchedList
    }
}

export const defaultAddInListMutation = {
    [ADD_IN_LIST](state, createdItem) {
        // determine if paginate or not, then add to list
        if (state.list.data) {
            state.list.data.unshift(createdItem)
        } else {
            state.list.unshift(createdItem)
        }
    },
}

export const defaultUpdateInListMutation = {
    [UPDATE_IN_LIST](state, updatedItem) {
        // determine if paginate or not, then add to list
        if (state.list.data) {
            let idx = state.list.data.findIndex(l => l.id === updatedItem.id)
            Object.assign(state.list.data[idx], updatedItem)
        } else {
            let idx = state.list.findIndex(l => l.id === updatedItem.id)
            Object.assign(state.list[idx], updatedItem)
        }
    },
}

export const defaultRemoveInListMutation = {
    [REMOVE_IN_LIST](state, deletedItem) {
        // determine if paginate or not, then add to list
        if (state.list.data) {
            let idx = state.list.data.findIndex(l => l.id === deletedItem.id)
            state.list.data.splice(idx, 1)
        } else {
            let idx = state.list.findIndex(l => l.id === deletedItem.id)
            state.list.splice(idx, 1)
        }
    }
}

/**
 * ROW
 */
export const defaultRemoveRowMutation = {
    [REMOVE_ROW](state, idx) {
        state.rows.splice(idx, 1)
    },
}

/**
 * OPTION
 */

export const defaultSetOptionMutation = {
    [SET_OPTION](state, options) {
        state.options = options
    }
}

export const defaultAddToOptionMutation = {
    [ADD_TO_OPTION](state, newOption) {
        state.options.unshift(newOption)
    }
}

export const defaultUpdateInOptionMutation = {
    [UPDATE_IN_OPTION](state, updatedOption) {
        let idx = state.options.findIndex(o => o.id === updatedOption.id)
        Object.assign(state.options[idx], updatedOption)
    }
}

export const defaultRemoveFromOptionMutation = {
    [REMOVE_FROM_OPTION](state, deletedOption) {
        let idx = state.options.findIndex(o => o.id === deletedOption.id)
        state.options.splice(idx, 1)
    }
}

/**
 * LOADING
 */

export const defaultSetLoading = {
    [SET_LOADING](state, loadingBoolean) {
        state.loading = loadingBoolean
    }
}
